import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { initAnalytics } from "./lib/analytics";
import "./index.css";

// GA4 + Consent Mode v2 — default denied, upgraded when user accepts cookies.
initAnalytics();

// Apply theme preference before first paint so there's no flash.
(() => {
  const stored = localStorage.getItem("hideaway-theme");
  const root = document.documentElement;
  if (stored === "dark") root.classList.add("dark");
  else if (stored === "hacker") root.classList.add("theme-hacker", "dark");
  else if (stored === "light") {
    /* already the default */
  } else {
    // Fall back to system preference on first visit.
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      root.classList.add("dark");
    }
  }
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
